import type { ReactNode } from "react";
import { t } from "@/shared/i18n";
import { Logo } from "@/shared/ui";
import estilos from "./PlantillaAcceso.module.css";

/** Marco de las pantallas sin sesión o sin permiso (ingresar, volver de Cognito). */
export function PlantillaAcceso({
  titulo,
  subtitulo,
  demo,
  children,
}: {
  readonly titulo: string;
  readonly subtitulo?: string;
  readonly demo: boolean;
  readonly children: ReactNode;
}) {
  return (
    <div className={estilos.fondo}>
      {demo && (
        <div className={estilos.demo} role="note">
          {t.demo.aviso}
        </div>
      )}
      <main className={estilos.centro}>
        <div className={estilos.tarjeta}>
          <div className={estilos.marca}>
            <Logo etiqueta={t.marca.nombre} />
            <span className={estilos.portal}>{t.marca.consola}</span>
          </div>
          <div>
            <h1>{titulo}</h1>
            {subtitulo && <p className={estilos.subtitulo}>{subtitulo}</p>}
          </div>
          {children}
        </div>
      </main>
      <footer className={estilos.pie}>
        {t.pie.empresa} · {t.pie.por} <b>{t.pie.simplgo}</b> · {t.pie.derechos(new Date().getFullYear())}
      </footer>
    </div>
  );
}
